import React, { useEffect, useRef, useState } from "react"
import withStyles from "react-jss"
import { InputPage, ResultsPage } from "./components"
import { INITIAL_INGREDIENTS, INITIAL_MIX_AND_SERVE } from "./utils/helper"
import FruitsImages from "./components/InputPage/FruitsImages"
import globalStyles, {
  MOBILE_BREAKPOINT,
  INPUT_FADEOUT,
  RESULTS_FADEOUT,
} from "./data/globalStyles"
import fonts from "./assets/fonts"
// import useWindowSize from "./hooks/useWindowSize"
// import { getBoundingCoordinates } from "./utils/helper"

const styles = {
  ...globalStyles,
  ...fonts,
  app: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "100vh",
    marginLeft: "calc(-3*var(--grid-margin))",
    marginRight: "calc(-3*var(--grid-margin))",
    padding: "4rem",
    [`@media only screen and (max-width: ${MOBILE_BREAKPOINT}px)`]: {
      padding: 0,
      marginLeft: "calc(-1.1*var(--grid-margin))",
      marginRight: "calc(-1.1*var(--grid-margin))",
      overflowX: "hidden",
      overflowY: "scroll",
    },
  },
}

const App = ({ classes }) => {
  const [ingredients, setIngredients] = useState([INITIAL_INGREDIENTS])
  const [mixAndServe, setMixAndServe] = useState(INITIAL_MIX_AND_SERVE)

  const clearCalculator = () => {
    setIngredients([INITIAL_INGREDIENTS])
    setMixAndServe(INITIAL_MIX_AND_SERVE)
  }

  const [show, setShow] = useState({
    inputPage: true,
    result: false,
  })
  // inputPage || result
  const [activeSection, setActiveSection] = useState("inputPage")

  const goToResults = ({ animationName }) => {
    if (animationName.includes(INPUT_FADEOUT)) {
      setActiveSection("result")
    }
  }

  const goBackToCalculator = ({ animationName }) => {
    if (animationName.includes(RESULTS_FADEOUT)) {
      setActiveSection("inputPage")
    }
  }

  const ref = useRef()
  const inputPageRef = useRef()

  // const { width, height } = useWindowSize()

  useEffect(() => {
    if (show.result) {
      // get position and scroll to the top of the ref container
    }
  }, [show])

  return (
    <div className={classes.app} ref={ref}>
      <InputPage
        ingredients={ingredients}
        setIngredients={setIngredients}
        mixAndServe={mixAndServe}
        setMixAndServe={setMixAndServe}
        show={show.inputPage}
        showObj={show}
        setShow={setShow}
        activeSection={activeSection}
        onAnimationEnd={goToResults}
        ref={inputPageRef}
      />
      <ResultsPage
        ingredients={ingredients.slice(0)}
        mixAndServe={mixAndServe}
        clearCalculator={clearCalculator}
        show={show.result}
        setShow={setShow}
        activeSection={activeSection}
        onAnimationEnd={goBackToCalculator}
      />
      <FruitsImages animate={show.result} />
    </div>
  )
}

export default withStyles(styles)(App)
